module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAI9JREFUOE9jZKAQMFKon4EKBrS3K4BdUVn5gCTXQPUxMrT33Ido/O1ItCFgzSzzQboYGcAc1v1EGwLXzKjAUFmiCAkDYg1B0wxxAQwQMgSLZlQD8LkEh2ZMA7AZAnYhy30GBsYHID+jxxT2dIDinf8KuDRjdwG2MMFiM0wZ/pQIcgmBBEaFpExS+sVUTLELABbaPBB/8fz5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/down.png
// module id = eDl4
// module chunks = 1